import styled, { css } from 'styled-components'

export const Container = styled.div`
  padding: 0px 10px;
`

export const PriceInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  input {
    width: 40%;
  }

  span {
    margin: 0px 10px;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 20px;

  > div {
    justify-content: flex-start;
    padding: 0px;
  }

  ${({ active }) => !active && css`
    cursor: not-allowed;
    width: fit-content;
    > div {
      pointer-events: none;
      user-select: none;
    }
    button {
      background: #4C4E55 !important;
    }
  `}
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  > label {
    color: #FFF;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  #select-input {
    background: transparent;
    > div:first-child {
      border-radius: 6px;
      padding: 12px;
      background: #191B24;
    }
    > div:last-child {
      position: relative;
    }
    .select-arrow  {
      color: #C4C4C4;
      margin-left: 12px;
    }
    .item {
      padding: 10px 12px;
      white-space: nowrap;
    }
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`

export const ErrorMessage = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: rgb(235, 87, 87);
  display: block;
  margin-top: 10px;
`
